import {
  TournamentsDefaultsClient,
  PlayPracticeGameDto,
  PracticeGameEntry,
} from "@nestcoinco/hyper-api-gateway-api-client";

import apiConfig from "../config/api-config";
import { axiosInstance } from "../config/axios-instance";

const tournamentsDefaultClient = new TournamentsDefaultsClient(
  apiConfig,
  undefined,
  axiosInstance
);

export const handlePlayPracticeGame = async (
  playPracticeDto?: PlayPracticeGameDto
): Promise<PracticeGameEntry> => {
  return (await tournamentsDefaultClient.playPracticeGame(playPracticeDto))
    .data;
};
